// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "* {\r\n   box-sizing: border-box;\r\n\r\n}\r\n\r\n.src-menuBar-searchBar-style__searchBarWrapper--1JL2- {\r\n  display: flex;\r\n \r\n  \r\n}\r\n\r\n", "",{"version":3,"sources":["webpack://src/menuBar/searchBar/style.css"],"names":[],"mappings":"AAAA;GACG,sBAAsB;;AAEzB;;AAEA;EACE,aAAa;;;AAGf","sourcesContent":["* {\r\n   box-sizing: border-box;\r\n\r\n}\r\n\r\n.searchBarWrapper {\r\n  display: flex;\r\n \r\n  \r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchBarWrapper": "src-menuBar-searchBar-style__searchBarWrapper--1JL2-"
};
export default ___CSS_LOADER_EXPORT___;
